import { Box, Button, Grid, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { IGraph, IGraphContainerDispatch } from "utils/interfaces/graph-report";
import { GraphType } from "utils/enums/graph";
import {
  getPagePayloadValues,
  hideLoaderForBatchApiCall,
  showLoaderForBatchApiCall,
} from "utils/helper";
import { EnrolmentOptionListSuccessPayload } from "store/studentEnrolment/types";
import { IEnrolmentOptions } from "utils/interfaces/student-enrolment";
import { useEffect, useState } from "react";
import { TermListSuccessPayload } from "store/term/types";
import { ITerm, ITermPagePayloadValues } from "utils/interfaces/term";
import { OrderByOptions } from "utils/enums/sorting";
import { DEFAULT_PAGE_NO, MAX_INT_VALUE } from "utils/constants/constant";
import GenericGraphComponent from "./GenericGraphComponent";

export type IEnrollmentGraphProps = IGraphContainerDispatch & IGraph;

const EnrollmentGraphs: React.FC<IEnrollmentGraphProps> = (props) => {
  const {
    termListRequest,
    getGraphDetailsRequest,
    enrolmentOptionListRequest,
  } = props;
  const history = useHistory();

  const [enrolmentOptionList, setEnrolmentOptionList] =
    useState<IEnrolmentOptions>();
  const [termList, setTermList] = useState<ITerm[]>([]);

  const onEnrolmentOptionListSuccess = (
    response: EnrolmentOptionListSuccessPayload
  ) => {
    setEnrolmentOptionList(response.enrolmentOptionList);
  };

  const getEnrolmentOptionList = () => {
    if (enrolmentOptionListRequest) {
      showLoaderForBatchApiCall();

      const payload = {
        values: {},
        callback: onEnrolmentOptionListSuccess,
      };

      enrolmentOptionListRequest(payload);
    }
  };

  const onTermListSuccess = (response: TermListSuccessPayload) => {
    setTermList(response.termList);
    hideLoaderForBatchApiCall();
  };

  const getTermList = () => {
    showLoaderForBatchApiCall();

    const values: ITermPagePayloadValues = getPagePayloadValues(
      "TermName",
      OrderByOptions.Asc,
      DEFAULT_PAGE_NO,
      MAX_INT_VALUE
    );
    values.termName = "";

    const payload = {
      values,
      callback: onTermListSuccess,
    };

    termListRequest(payload);
  };

  useEffect(() => {
    getEnrolmentOptionList();
    getTermList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="wrapper">
      <Box className="content-header">
        <Typography variant="h2" className="heading">
          Graphs
        </Typography>
        <Button
          variant="outlined"
          className="btn-back"
          onClick={() => history.goBack()}
        >
          Back
        </Button>
      </Box>
      {!!termList.length && enrolmentOptionList && (
        <Grid
          container
          spacing={{ xs: "16px", lg: "20px", xl: "24px" }}
          className="content-container"
        >
          <Grid item xs={12}>
            <GenericGraphComponent
              key={`${GraphType.EnrolmentType}-graphComponent`}
              optionList={enrolmentOptionList?.enrolmentType ?? []}
              graphType={GraphType.EnrolmentType}
              termList={termList}
              getGraphDetailsRequest={getGraphDetailsRequest}
            />
          </Grid>
          <Grid item xs={12}>
            <GenericGraphComponent
              key={`${GraphType.Sector}-graphComponent`}
              optionList={enrolmentOptionList?.sector ?? []}
              graphType={GraphType.Sector}
              termList={termList}
              getGraphDetailsRequest={getGraphDetailsRequest}
            />
          </Grid>
          <Grid item xs={12}>
            <GenericGraphComponent
              key={`${GraphType.SiteService}-graphComponent`}
              optionList={enrolmentOptionList?.siteOrService ?? []}
              graphType={GraphType.SiteService}
              termList={termList}
              getGraphDetailsRequest={getGraphDetailsRequest}
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default EnrollmentGraphs;
